/**
 * @generated SignedSource<<d12f6e7964219ea106e89139044f3b85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilteredSurveyInput = {
  PIISurveys?: boolean | null;
  historicSurveys?: boolean | null;
  trackingParams?: ReadonlyArray<TrackingParam | null> | null;
  webcamSurveys?: boolean | null;
};
export type TrackingParam = {
  key: string;
  value: string;
};
export type DashboardQuery$variables = {
  barcCookieModalOpen: boolean;
  input: FilteredSurveyInput;
};
export type DashboardQuery$data = {
  readonly surveys: {
    readonly pageInfo: {
      readonly totalCount: number | null;
    };
  } | null;
  readonly targetRedemptionValue: {
    readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_target">;
  } | null;
  readonly walletBalance: {
    readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_balance">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BarcModal_cookiesRef" | "MoreSurveysBanner_profileUrlRef" | "SurveyListFragment_surveysRef">;
};
export type DashboardQuery = {
  response: DashboardQuery$data;
  variables: DashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "barcCookieModalOpen"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subUnitAmount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedeemBanner_balance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedeemBanner_target"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "SurveyListFragment_surveysRef"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "MoreSurveysBanner_profileUrlRef"
      },
      {
        "condition": "barcCookieModalOpen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BarcModal_cookiesRef"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "panelistCost",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "redemptionAmount",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Survey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrencyAmount",
                    "kind": "LinkedField",
                    "name": "rewardAmount",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LockedSurveyInfo",
                    "kind": "LinkedField",
                    "name": "lockedInfo",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DurationDetails",
                    "kind": "LinkedField",
                    "name": "durationDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "providerDuration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AdminSurveyData",
                    "kind": "LinkedField",
                    "name": "adminData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rankScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyGuid",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endlessProfilerUrl",
        "storageKey": null
      },
      {
        "condition": "barcCookieModalOpen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CookieConnection",
            "kind": "LinkedField",
            "name": "cookies",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CookieEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Cookie",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cookieId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CookieConsent",
                        "kind": "LinkedField",
                        "name": "consent",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "145ac0ad5dccda24079b87636c7640e4",
    "id": null,
    "metadata": {},
    "name": "DashboardQuery",
    "operationKind": "query",
    "text": "query DashboardQuery(\n  $input: FilteredSurveyInput!\n  $barcCookieModalOpen: Boolean!\n) {\n  walletBalance {\n    ...RedeemBanner_balance\n    id\n  }\n  targetRedemptionValue {\n    ...RedeemBanner_target\n  }\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    id\n  }\n  ...SurveyListFragment_surveysRef_2VV6jB\n  ...MoreSurveysBanner_profileUrlRef\n  ...BarcModal_cookiesRef @include(if: $barcCookieModalOpen)\n}\n\nfragment BarcModal_cookiesRef on Query {\n  cookies {\n    edges {\n      node {\n        cookieId\n        description\n        consent {\n          status\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MoreSurveysBanner_profileUrlRef on Query {\n  endlessProfilerUrl\n}\n\nfragment RedeemBanner_balance on WalletBalance {\n  amount {\n    formatted\n    subUnitAmount\n  }\n  id\n}\n\nfragment RedeemBanner_target on AmountDenomination {\n  panelistCost {\n    subUnitAmount\n  }\n  redemptionAmount {\n    formatted\n  }\n}\n\nfragment SurveyCard_survey on Survey {\n  id\n  iconUrl\n  rewardAmount {\n    subUnitAmount\n  }\n  lockedInfo {\n    title\n  }\n  title\n  url\n  status\n  supportId\n  durationDetails {\n    providerDuration\n  }\n  tags\n  adminData {\n    rankScore\n    surveyGuid\n  }\n}\n\nfragment SurveyListFragment_surveysRef_2VV6jB on Query {\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    edges {\n      node {\n        id\n        tags\n        status\n        ...SurveyCard_survey\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "14f37d2bbe31bb7512e1a567a1c997ba";

export default node;
